// extracted by mini-css-extract-plugin
export var cta = "GlobalLink-module--cta--300a5";
export var listItem = "GlobalLink-module--listItem--548e6";